import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GalleryLayout15 } from '@components/gallery/components/gallery-layout-15/model';
import { ImageComponent } from '@shared/components/image';
import { QuoteComponent } from '@shared/components/quote';

@Component({
  selector: 'app-gallery-layout-15',
  imports: [QuoteComponent, ImageComponent],
  templateUrl: './gallery-layout-15.component.html',
  styleUrl: './gallery-layout-15.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout15Component {
  readonly data = input.required<GalleryLayout15>();
}
